module.exports = __webpack_public_path__ + "img/configuracao.ae38b9e4.svg";